import React from "react";
import { Card, CardContent, Avatar, Box, Typography, Chip } from "@mui/material";
import { Person, WorkOutline, MedicalServices } from "@mui/icons-material";
import pic from "../assets/blue.png";

export default function CareTeamCard(props) {
  return (
    <Card
      sx={{
        marginBottom: 3,
        borderRadius: 3,
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        transition: "all 0.3s ease",
        "&:hover": {
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
          transform: "translateY(-4px)",
        },
      }}
    >
      <CardContent>
        <Box display="flex" alignItems="flex-start" gap={3}>
          {/* Profile Image */}
          <Avatar
            src={
              props.photoUrl && props.photoUrl.length > 0
                ? `${process.env.REACT_APP_Documents_URL}/${encodeURI(props.photoUrl)}`
                : pic
            }
            alt={props.firstName}
            sx={{
              width: 100,
              height: 100,
              border: "4px solid #31A5D7",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            }}
          />

          {/* Content Section */}
          <Box flex={1}>
            {/* Name */}
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                color: "#2c3e50",
                marginBottom: 1,
              }}
            >
              {props.firstName}
            </Typography>

            {/* Provider Name */}
            {props.providerName && props.providerName !== "null" && props.providerName !== "undefined" && (
              <Box display="flex" alignItems="center" gap={1} marginBottom={1}>
                <Person sx={{ color: "#31A5D7", fontSize: 20 }} />
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 600,
                    color: "#34495e",
                  }}
                >
                  {props.providerName}
                </Typography>
              </Box>
            )}

            {/* Role */}
            {props.role && props.role !== "null" && props.role !== "undefined" && (
              <Box display="flex" alignItems="center" gap={1} marginBottom={1}>
                <WorkOutline sx={{ color: "#27ae60", fontSize: 20 }} />
                <Typography
                  variant="body2"
                  sx={{
                    color: "#555",
                  }}
                >
                  {props.role}
                </Typography>
              </Box>
            )}

            {/* Title */}
            {props.title && props.title !== "null" && props.title !== "undefined" && (
              <Box display="flex" alignItems="center" gap={1} marginBottom={1}>
                <MedicalServices sx={{ color: "#e74c3c", fontSize: 20 }} />
                <Typography
                  variant="body2"
                  sx={{
                    color: "#555",
                  }}
                >
                  {props.title}
                </Typography>
              </Box>
            )}

            {/* Responsibilities */}
            {props.responsiblities && props.responsiblities !== "null" && props.responsiblities !== "undefined" && (
              <Chip
                label={props.responsiblities}
                sx={{
                  marginTop: 1,
                  backgroundColor: "#FCBE13",
                  color: "#000",
                  fontWeight: 600,
                }}
              />
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
